import React from 'react';
import {
  View,
  StyleSheet,
  ScrollView,
  Platform,
} from 'react-native';
import { UserDataConsumer, ShopGearBanner} from 'fitbeat.react-native-components';
import { connect } from 'react-redux';
import { loadInitialStateForDashboard, trackingTileSelected,
  shopForFitbeatGearSelected, setNutritionRatingAndgetNutritionStats } from './actions';
import { UserServiceClient } from 'fitbeat.api-clients';
import { getApiConfig } from '../config';
import { AuthTokenBuilder } from '../utils/authTokenBuilder';
import { GoogleAnalytics } from '../services/google-analytics';
import { translate } from 'react-i18next';
import TrackingHealthTile from './components/tracking-health-tile';
import TrackingWorkoutTile from './components/tracking-workout-tile';
import { toggleTrackingOnboardingModalVisible } from '../ui';
import { Logger } from '../utils';
import { StartHeartRateTestScan } from '../HomeWorkouts/heartRateActions';
import Theme from '../theme';
import { LeaderboardHistoryScreen } from './components/LeaderboardHistory';

const isWeb = Platform.OS === 'web';
class TrackingDashboard extends React.Component {
  onFocusListener;

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    }
    const { user: { userProfile } } = this.props;
    this.props.loadInitialStateForDashboard();
  }

  navigationDidFocus = () => {
    this.props.loadInitialStateForDashboard();
  }

  componentWillUnmount = () => {
    this.onFocusListener.remove();
  }

  componentDidMount = () => {
    this.onFocusListener = this.props.navigation.addListener('didFocus', () => this.navigationDidFocus());
  }

  closeSetupModal = async () => {
    try {
      this.setState({ isLoading: true });
      const { user: { userProfile, userProfileService } } = this.props;
      userProfile.shouldShowTrackingOnboarding = false;
      await userProfileService.updateUserProfile(userProfile);
      this.setState({ isLoading: false });
    } catch (error) {
      Logger.notify(error);
      this.props.toggleTrackingOnboardingModalVisible(false);
      this.setState({ isLoading: false });
    } finally {
      await this.setState({ isLoading: false });
      this.props.toggleTrackingOnboardingModalVisible(false);
    }
  }

  render() {
    const {
      user: { userProfile, userProfileService },
      weeklyWorkoutProgress,
      t,
      } = this.props;
    return (
        <View style={styles.container}>
          <View style={styles.paddedContainer}>
            <React.Fragment>
              <ScrollView>
                <TrackingWorkoutTile
                trackingTileSelected={this.props.trackingTileSelected}
                isLoading={this.props.isLoadingWorkout}
                loadingError={this.props.workoutLoadError}
                workoutStats={this.props.workoutStats}
                navigation={this.props.navigation}
                totals={this.props.statistics ? this.props.statistics.totals : 0}
                workoutStatsDateRange={this.props.workoutDateRange}
                userProfile={userProfile}
                workoutSessionService={this.props.user.workoutSessionService}
                weeklyWorkoutProgress={weeklyWorkoutProgress}
                />
                <TrackingHealthTile
                trackingTileSelected={this.props.trackingTileSelected}
                isLoading={this.props.isLoadingHealth}
                loadingError={this.props.healthLoadError}
                scanStats={this.props.scanStats}
                navigation={this.props.navigation}
                userProfile={userProfile}
                userProfileService={userProfileService}
                 />
                <LeaderboardHistoryScreen
                  navigation={this.props.navigation}
                  />
              </ScrollView>
              {Platform.OS !== 'web' &&
                <ProfileHeartRateSetup
                  userProfile={userProfile}
                  heartRateScanAction={StartHeartRateTestScan}
                  userUpdateFunc={userProfileService.updateUserProfileAsync}
                  updateUserHeartRateMonitors={userProfileService.updateUserHeartRateMonitors}
                />
              }
            </React.Fragment>
          </View>
          {!this.props.isLoading && !isWeb &&
            <TrackingGaugeLegend /> 
          }
        </View>
      )
  }
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: Theme.GREY_LIGHT,
    height: '100%',
  },
  paddedContainer: {
    paddingHorizontal: 10,
    zIndex: 1000,
    flex: 1,
  },
  modalContainer: {
    flex: 1,
  },
  nutritionLogo: {
    alignSelf: 'center',
    width: 40,
    height: 40,
    margin: 2.5,
    marginHorizontal: 10,
    marginVertical: 20,
    marginTop: 50
  },
});

const mapStateToProps = (state) => {
  const { isLoading, isLoadingWorkout, isLoadingHealth, isLoadingNutrition,
    error, workoutLoadError, healthLoadError, nutritionLoadError,
    monthAndYearRange, selectedMonthAndYear, workoutHeaderDateRange, lastScanDate } = state.tracking.view;
  const { workoutDateRange } = state.tracking.view.dashboard;
  const { stats, workoutStats, scanStats, nutritionStats } = state.tracking.data.dashboard;
  const { weeklyWorkoutProgress } = state.tracking.data;

  return {
    error,
    workoutLoadError,
    healthLoadError,
    nutritionLoadError,
    isLoading,
    isLoadingWorkout,
    isLoadingHealth,
    isLoadingNutrition,
    monthAndYearRange,
    selectedMonthAndYear,
    workoutDateRange,
    workoutHeaderDateRange,
    statistics: stats,
    workoutStats,
    scanStats,
    lastScanDate,
    isScanReportModalVisible: state.ui.scanReportModalVisible,
    isTrackingOnboardingModalVisible: state.ui.trackingOnboardingModalVisible,
    nutritionStats,
    weeklyWorkoutProgress,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const { nutritionService } = ownProps.user;
  const userServiceClient = new UserServiceClient(getApiConfig(), fetch, console.log, new AuthTokenBuilder(), GoogleAnalytics);
  return {
    loadInitialStateForDashboard: () => dispatch(loadInitialStateForDashboard(userServiceClient, new Date())),
    toggleStatsGraphModalVisible: (visible) => dispatch(toggleStatsGraphModalVisible(visible)),
    toggleScanReportModalVisible: (visible) => dispatch(toggleScanReportModalVisible(visible)),
    toggleTrackingOnboardingModalVisible: (visible) => dispatch(toggleTrackingOnboardingModalVisible(visible)),
    trackingTileSelected: (tileName) => dispatch(trackingTileSelected(tileName)),
    shopForFitbeatGearSelected: () => dispatch(shopForFitbeatGearSelected()),
    setNutritionRating: (rating) => dispatch(setNutritionRatingAndgetNutritionStats(
      nutritionService, userServiceClient, rating)),
  };
};

TrackingDashboard = UserDataConsumer(connect(mapStateToProps, mapDispatchToProps)(TrackingDashboard));
export default translate(['stats', 'tracking'], { wait: true })(TrackingDashboard);
